import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getLeagueMembersData,
    suspendLeague,
    removeLeagueSuspension,
    deleteLeague,
    leaveLeague,
    updateLeagueNamePost,
} from './../../actions/LeagueActions';
import { concat, find } from 'lodash';
import LeagueShare from './league-share';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import GeneralPopUp from './../GeneralPopUp';
import AdBottom from '../AdBottom';
import trackEventsObj from '../../constants/new-pageTrackEvents'

class LeagueSettings extends Component {
    constructor(props) {
        super(props);
        this.pageNumber = 1;
        this.summary = {};
        this.vPageChunk = common.isMobile() ? 20 : 25;
    }

    setInitialState = () => {
        this.setState({
            mergedLeagueMembers: [],
            isEditEnabled: false,
            leagueName: '',
            previousLeagueName: '',
            isDisabled: true,
            popupProps: {
                message: '',
                inlineMessage: '',
                popupWrapperClass: '',
                iconClass: '',
                showPopup: false,
            },
            areAllLoaded: false,
            dataForPost: {},
            showShare: false,
            TotalMembers : 0
        });
    };
    isFooterInView = () => {
        const elem = document.querySelector('.footer-wrap');
        return common.isElementInViewport(elem);
    };
    onVisibilityChange = (callback) => {
        const _this = this;
        let old_visible;
        return function () {
            let visible = _this.isFooterInView();
            if (visible !== old_visible) {
                old_visible = visible;
                if (typeof callback === 'function') {
                    callback(visible);
                }
            }
        }
    };
    handler = this.onVisibilityChange(function (visibility) {
        if (this.nextBtn && this.dummyBtn) {
            if (visibility) {
                this.nextBtn.classList.remove('si-sticky-btn');
                this.dummyBtn.style.display = 'none';
            } else {
                this.nextBtn.classList.add('si-sticky-btn');
                this.dummyBtn.style.display = '';
            }
        }
    }.bind(this));

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handler);
    }

    componentWillMount() {
        this.setInitialState();
    }

    componentDidMount() {
        common.pageViewTracking("", trackEventsObj["LeagueSettings"]);
        this.getLeagueMembers();
        document.addEventListener('scroll', this.handler);
        this.handler();
    }

    onShareTap = () => {
        common.customTracking('Invite Users-Icon','/uclfantasy/leagues/private/settings/');
        this.setState((previousState) => {
            return { showShare: !previousState.showShare };
        });
    };
    getLeagueMembers = () => {
        if (this.props.isLeagueMemberLoading) return;
        const { leagueID } = this.props.match.params;
        if (!leagueID) return;
        common.showLoader();
        this.props.getLeagueMembersData(leagueID, this.pageNumber, this.vPageChunk).then(() => {
            common.hideLoader();
            const leagueMembers = this.props.leagueMembers;
            const { mLeagueMembersSummary, mLeagueMembersDetails } = leagueMembers;
            if(this.pageNumber == 1 && mLeagueMembersSummary){
                this.setState({TotalMembers : mLeagueMembersSummary.TotalMembers})
            }
            const errorKeyFromTrans = apiError.leagues;
            const message = this.props.trans[errorKeyFromTrans];
            if (!leagueMembers) {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.handleToast(stateToSet);
            } else {
                
                const mergedLeagueMembers = concat(this.state.mergedLeagueMembers, mLeagueMembersDetails);
                this.setState({ mergedLeagueMembers });
                if (this.pageNumber === 1) {
                    this.summary = mLeagueMembersSummary;
                    let LeagueName = mLeagueMembersSummary.LeagueName;
                    if (+mLeagueMembersSummary['IsDefaultLeague'] === 1) {
                        //LeagueName = this.props.trans['defaultLeagueName'].replace('{TEAM_NAME}', LeagueName);
                    }
                    this.setState({
                        leagueName: LeagueName,
                        previousLeagueName: LeagueName,
                    });
                }
                if (this.summary && this.summary['TotalMembers'] === mergedLeagueMembers.length) {
                    this.setState({
                        areAllLoaded: true
                    });
                }
                ++this.pageNumber;
            }
        });
    };
    onSuspend = (UserId, UserTeamId, LeagueId) => {
        const { trans } = this.props;
        this.handleToast({
            message: trans['suspend_user_msg'],
            popupWrapperClass: 'si-small-popup si-popup-warning',
            iconClass: 'icon-ucl-warning-icon',
            showPopup: true,
            primaryBtnText: trans['confirm'],
            secondaryBtnText: trans['cancel'],
            primaryBtnHandler: this.suspendPostCall.bind(this),
            secondaryBtnHandler: this.resetToast.bind(this),
        });
        this.setState({ dataForPost: { UserId, UserTeamId, LeagueId } });
    };
    suspendPostCall = () => {
        common.showLoader();

        const GUID = common.getGUID();
        const { UserId, UserTeamId, LeagueId } = this.state.dataForPost;
        this.props.suspendLeague(GUID, UserId, UserTeamId, LeagueId).then(() => {
            common.hideLoader();
            const response = this.props.suspendResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.suspension[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Suspend', '/uclfantasy/leagues/private/settings/');
                const foundUser = find(this.state.mergedLeagueMembers, { UserId });
                foundUser.IsLocked = 2;
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true,
                    mergedLeagueMembers: [...this.state.mergedLeagueMembers]
                });
            } else {
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            }
        });
    };
    onUnSuspend = (UserId, UserTeamId, LeagueId) => {
        const { trans } = this.props;
        this.handleToast({
            message: trans['un_suspend_user_msg'],
            popupWrapperClass: 'si-small-popup si-popup-warning',
            iconClass: 'icon-ucl-warning-icon',
            showPopup: true,
            primaryBtnText: trans['confirm'],
            secondaryBtnText: trans['cancel'],
            primaryBtnHandler: this.onUnSuspendPostCall.bind(this),
            secondaryBtnHandler: this.resetToast.bind(this),
        });
        this.setState({ dataForPost: { UserId, UserTeamId, LeagueId } })
    };
    onUnSuspendPostCall = () => {
        common.showLoader();

        const GUID = common.getGUID();
        const { UserId, UserTeamId, LeagueId } = this.state.dataForPost;
        this.props.removeLeagueSuspension(GUID, UserId, UserTeamId, LeagueId).then(() => {
            common.hideLoader();
            const response = this.props.removeSuspensionResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.suspension[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Unsuspend','/uclfantasy/leagues/private/settings/');
                const foundUser = find(this.state.mergedLeagueMembers, { UserId });
                foundUser.IsLocked = 0;
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true,
                    mergedLeagueMembers: [...this.state.mergedLeagueMembers]
                });
            } else {
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            }
        });
    };
    onLeaveLeague = (leagueID, LeagueCode) => {
        const { trans } = this.props;
        this.handleToast({
            message: trans['exit_league_msg'],
            popupWrapperClass: 'si-small-popup si-popup-warning',
            iconClass: 'icon-ucl-warning-icon',
            showPopup: true,
            primaryBtnText: trans['confirm'],
            secondaryBtnText: trans['cancel'],
            primaryBtnHandler: this.onLeavePostCall.bind(this),
            secondaryBtnHandler: this.resetToast.bind(this),
        });
        this.setState({ dataForPost: { leagueID, LeagueCode } })
    };
    onLeavePostCall = () => {
        common.showLoader();

        const GUID = common.getGUID();
        const { leagueID, LeagueCode } = this.state.dataForPost;
        this.props.leaveLeague(GUID, leagueID, LeagueCode).then(() => {

            common.hideLoader();
            const response = this.props.leaveLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.leaveLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Exit League', '/uclfantasy/leagues/private/settings/');
                sessionStorage.setItem('leagueDeleted', true);
                sessionStorage.setItem('display_message', message);
                this.props.history.push('/leagues');
            } else {
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            }
        });
    };
    onDeleteLeague = (leagueID, LeagueCode) => {
        const { trans } = this.props;
        this.handleToast({
            message: trans['delete_league_msg'],
            popupWrapperClass: 'si-small-popup si-popup-warning',
            iconClass: 'icon-ucl-warning-icon',
            showPopup: true,
            primaryBtnText: trans['confirm'],
            secondaryBtnText: trans['cancel'],
            primaryBtnHandler: this.onDeleteLeaguePostCall.bind(this),
            secondaryBtnHandler: this.resetToast.bind(this),
        });
        this.setState({ dataForPost: { leagueID, LeagueCode } })
    };
    onDeleteLeaguePostCall = () => {
        common.showLoader();

        const GUID = common.getGUID();
        const { leagueID, LeagueCode } = this.state.dataForPost;
        this.props.deleteLeague(GUID, leagueID, LeagueCode).then(() => {
            common.hideLoader();
            const response = this.props.deleteLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.deleteLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Delete League', '/uclfantasy/leagues/private/settings/');
                sessionStorage.setItem('leagueDeleted', true);
                sessionStorage.setItem('display_message', message);
                this.props.history.push('/leagues');
            } else {
                this.handleToast({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            }
        });
    };
    makeDone = (leagueID) => {
        // common.customTracking('Done');
        const GUID = common.getGUID();
        const { leagueName, previousLeagueName } = this.state;
        if (leagueName === previousLeagueName) {
            this.toggleEdit(false);
        } else {
            common.showLoader();
            this.props.updateLeagueName(GUID, leagueName, leagueID).then(() => {
                common.hideLoader();
                const response = this.props.updateLeagueNameResponse;
                const retVal = response.Meta['RetVal'];
                const errorKeyFromTrans = apiError.updateLeagueName[retVal];
                const message = this.props.trans[errorKeyFromTrans];
                if (response.Meta['Success'] && retVal === 1) {
                    common.customTracking('Change League Name', '/uclfantasy/leagues/private/settings/edit/');
                    this.setState({ previousLeagueName: leagueName });
                    this.setState({ isDisabled: this.isDisabled(leagueName) });
                    this.handleToast({
                        message,
                        resetToast: this.resetToast,
                        isToast: true,
                        popupWrapperClass: 'si-warning-toast si-success-popup',
                        iconClass: 'icon-ucl-tick',
                        showPopup: true,
                        mergedLeagueMembers: [...this.state.mergedLeagueMembers]
                    });
                    this.toggleEdit(false);
                } else {
                    let stateToSet = {
                        inlineMessage: message,
                    };
                    this.setState(stateToSet);
                }
            });
        }
    };
    handleToast = (popupState) => {
        this.setState({ popupProps: popupState });
    };
    isDisabled = (value) => {
        return (value.length === 0) ||
            (value.trim().length > config.MAX_LEAGUE_CODE_LENGTH) ||
            (value.trim().length < config.MIN_LEAGUE_NAME_LENGTH) ||
            value === this.state.previousLeagueName;
    };
    handleChange = (event) => {
        const val = common.validateInput(event.target.value);
        this.setState({ leagueName: val, isDisabled: this.isDisabled(val) });
    };
    resetToast = () => {
        this.handleToast({ popupProps: { showPopup: false, message: '', } });
    };
    toggleEdit = (isEditEnabled) => {
        // common.customTracking('Change Name');
        common.pageViewTracking("", trackEventsObj["LeagueSettingsEdit"]);
        this.setState({ isEditEnabled });
    };
    cancelEdit = () => {
        this.setState({ leagueName: this.state.previousLeagueName, isEditEnabled: false });
    };
    onBackClick = () => {
        return this.props.history.goBack();
    };

    render() {
        const { trans, leagueMembers, constraints } = this.props;
        if (leagueMembers.length === 0) return null;
        const { leagueID } = this.props.match.params;
        const { mLeagueMembersSummary } = leagueMembers;
        let { IsAdmin, LeagueCode, TotalMembers, LeagueId, LeagueName, ShareLoad } = mLeagueMembersSummary;
        const { mergedLeagueMembers, inlineMessage, leagueName, isDisabled, isEditEnabled, areAllLoaded, showShare } = this.state;
        const { showPopup, popupWrapperClass, iconClass, message, primaryBtnText, secondaryBtnText, primaryBtnHandler, secondaryBtnHandler, resetToast, isToast } = this.state.popupProps;
        IsAdmin = +IsAdmin === 1;
        const canDeleteLeague = IsAdmin && this.state.TotalMembers === 1;
        const LeagueNameWithError = common.makeClasses({
            'si-league-name': true,
            'si-error': inlineMessage
        });
        const popupProps = {
            showPopup,
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass,
            resetToast,
            primaryBtnText,
            secondaryBtnText,
            primaryBtnHandler,
            secondaryBtnHandler
        };
        const dataToShare = { LeagueCode, LeagueId, LeagueName, ShareLoad, constraints };
        const doneClass = common.makeClasses({
            'si-cta-actions': true,
            'si-disabled': isDisabled
        });
        const doneDesktopClass = common.makeClasses({
            'si-btn': true,
            'si-btn-disabled': isDisabled,
            'si-btn-primary': !isDisabled,
        });
        return <div className="si-main-component si-manage-team si-no-anim si-leagues">
            <div className="si-container">
                <div className="si-top-section">
                    <div className="si-leagues-header si-flexBox">
                        <div className="si-back-btn si-cols">
                            { isEditEnabled ? <i className="icon-ucl-back_arrow si-display-block"
                                onClick={ () => this.cancelEdit() } /> : null }
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>{ trans['league_settings'] }</span>
                            <div className="si-members-count">
                                <span className="si-count">{ common.memberNotation(this.state.TotalMembers) } </span><span
                                    className="si-txt">{ trans['members'] }</span>
                            </div>
                        </div>
                        { IsAdmin ? <div className="si-common-menu">
                            { !isEditEnabled ?
                                <div className="si-cta-actions" onClick={ () => this.toggleEdit(true) }>
                                    <span>{ trans['edit'] }</span>
                                </div> : null }
                            { isEditEnabled ?
                                <div className={ doneClass } onClick={ () => this.makeDone(leagueID) }>
                                    <span>{ trans['done'] }</span>
                                </div> : null }
                        </div> : null }
                        { IsAdmin ? <div className="si-subs-mode-btn si-flexBox">
                            { !isEditEnabled ?
                                <div className="si-btn si-btn-secondary" onClick={ () => this.toggleEdit(true) }>
                                    <span>{ trans['edit'] }</span>
                                </div> : null }
                            { isEditEnabled ? <div className="si-btn si-no-border-btn" onClick={ () => this.cancelEdit() }>
                                <span>{ trans.cancel }</span>
                            </div> : null }
                            { isEditEnabled ?
                                <div className={ doneDesktopClass } onClick={ () => this.makeDone(leagueID) }>
                                    <span>{ trans.done }</span>
                                </div> : null }
                        </div> : null }


                    </div>
                </div>
                <div className="si-leagues-container">
                    <div className="si-lg-settings">
                        { isEditEnabled ? <div className={ LeagueNameWithError }>
                            <div className="si-title">{ trans['league_name'] }</div>
                            <div className="si-input-wrap">
                                <label>{ config.MAX_LEAGUE_NAME_LENGTH - this.state.leagueName.length }</label>
                                <input type="text" name="leagueName"
                                    maxLength={ config.MAX_LEAGUE_NAME_LENGTH }
                                    value={ leagueName }
                                    onChange={ (e) => this.handleChange(e) }
                                    placeholder={ trans['enter_league_name_placeholder'] } />
                            </div>
                            { inlineMessage ? <div className="si-error-msg">
                                <span>{ inlineMessage }</span>
                            </div> : null }
                        </div> : null }

                        { !isEditEnabled ?
                            <div className="si-league-name">
                                <div className="si-title">{ trans['league_name'] }</div>
                                <div className="si-grp-name">
                                    <span>{ leagueName }</span>
                                </div>
                            </div> : null }


                        <div className="si-invite-wrap">
                            <div className="si-lightBox" />
                            <div className="si-members-count">
                                <span className="si-count">{ common.memberNotation(this.state.TotalMembers) } </span><span
                                    className="si-txt">{ trans['members'] }</span>
                            </div>
                            <div className="si-invite-list">
                                <div className="si-title-wrp" onClick={ () => this.onShareTap() }>
                                    <span>{ trans['invite_to_league'] }</span>
                                </div>
                                { mergedLeagueMembers.map(eachMember => {
                                    const {
                                        BadgeId,
                                        IsLocked,
                                        UserGuid,
                                        UserId,
                                        UserName,
                                        UserTeamId
                                    } = eachMember;
                                    const imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                    const isCurrUserAdmin = UserGuid === common.getGUID();
                                    let memberName = `${UserName}`;
                                    memberName += isCurrUserAdmin ? `${trans['you']}` : ``;
                                    return <div className="si-list-items" key={ UserId }>
                                        <div className="si-users-wrp">
                                            <div className="si-img-wrp">
                                                <img src={ imgSrc } alt={ UserId } />
                                            </div>
                                            <div className="si-league-items">{ memberName }</div>
                                        </div>
                                        { (IsAdmin && !isCurrUserAdmin) ?
                                            ((IsLocked === 2) ? <div className="si-suspend-txt"
                                                onClick={ () => this.onUnSuspend(UserId, UserTeamId, leagueID) }>{ trans['unsuspend'] }</div> :
                                                <div className="si-suspend-txt"
                                                    onClick={ () => this.onSuspend(UserId, UserTeamId, leagueID) }>{ trans['suspend'] }</div>) : null }
                                    </div>
                                }) }
                                { areAllLoaded ? null : <div className="si-data-row si-tRow si-tbl-loader">
                                    <div className="si-block si-tCel si-rank">

                                    </div>
                                    <div className="si-block si-plyr-info-wrap si-tCel">
                                        <div className="si-loader-dots" >
                                            {/* <span className="si-dots si-dot1" />
                                            <span className="si-dots si-dot2" />
                                            <span className="si-dots si-dot3" /> */}
                                            <div className="si-btn si-btn-primary" onClick={ () => this.getLeagueMembers() }>
                                                <span>{ trans['loadFiftyMore'] || "Load 50 more rows" }</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="si-block si-md si-tCel">
                                    </div>
                                    <div className="si-block si-total si-tCel">
                                    </div>
                                </div> }
                            </div>
                        </div>
                        <div className="si-btn-wrp si-dummy-btn" ref={ (ref) => this.dummyBtn = ref }>
                            <div className="si-btn"><span>TEST</span></div>
                        </div>
                        <div className="si-btn-wrp si-sticky-btn" ref={ (ref) => this.nextBtn = ref }>
                            { (!IsAdmin) ? <div className="si-btn si-no-border-btn"
                                onClick={ () => this.onLeaveLeague(leagueID, LeagueCode) }>
                                <span>{ trans['exit_league'] }</span>
                            </div> : null }
                            { (canDeleteLeague) ? <div className="si-btn si-no-border-btn"
                                onClick={ () => this.onDeleteLeague(leagueID, LeagueCode) }>
                                <span>{ trans['delete_league'] }</span>
                            </div> : null }
                        </div>
                    </div>
                </div>
                <AdBottom />
            </div>
            <GeneralPopUp { ...popupProps } />
            { showShare ? <LeagueShare { ...dataToShare } isFromSettings = {true} trans={ trans } toHide={ this.onShareTap.bind(this) } /> : null }
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeagueMembersData: (leagueID, pageNo, chunkSize) => dispatch(getLeagueMembersData(leagueID, pageNo, chunkSize)),
        suspendLeague: (GUID, MemberId, MemberTeamId, LeagueId) => dispatch(suspendLeague(GUID, MemberId, MemberTeamId, LeagueId)),
        removeLeagueSuspension: (GUID, MemberId, MemberTeamId, LeagueId) => dispatch(removeLeagueSuspension(GUID, MemberId, MemberTeamId, LeagueId)),
        deleteLeague: (GUID, leagueID, leagueCode) => dispatch(deleteLeague(GUID, leagueID, leagueCode)),
        leaveLeague: (GUID, leagueID, leagueCode) => dispatch(leaveLeague(GUID, leagueID, leagueCode)),
        updateLeagueName: (GUID, leagueName, leagueID) => dispatch(updateLeagueNamePost(GUID, leagueName, leagueID)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        isLeagueMemberLoading: state.leaguesData.isLeagueMemberLoading,
        leagueMembers: state.leaguesData.leagueMembers,
        deleteLeagueResponse: state.leaguesData.deleteLeagueResponse,
        leaveLeagueResponse: state.leaguesData.leaveLeagueResponse,
        suspendResponse: state.leaguesData.suspendResponse,
        removeSuspensionResponse: state.leaguesData.removeSuspensionResponse,
        updateLeagueNameResponse: state.leaguesData.updateLeagueNameResponse,
        constraints: state.appData.constraints
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(LeagueSettings));


// WEBPACK FOOTER //
// ./src/components/leagues/league-settings.js